import _ from 'lodash';
import { compose, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';


const logTransformer = action => {
  if(action.result) {
    action = _.assign({}, action, {type: action.type + ":" + action.result});
  }
  return action;
}

function createAppStore(reducer, initialState = {}) {

  let middleware = [
    thunkMiddleware,
    //routerMiddleware(history),
    createLogger({ 
      duration: true,
      timestamp: true,
      collapsed: true,
      actionTransformer: logTransformer,
    })
  ];

  const store = createStore(reducer, initialState, applyMiddleware(...middleware));
  return store;
}
export { createAppStore }